import { FiCreditCard } from "react-icons/fi";

export default function OrderSummary({
  subtotal_amount,
  discount_amount,
  coupon_amount,
  total_amount,
  shipping_amount,
  tax_amount,
  payable_amount,
}) {
  const formatPrice = (amount) =>
    Number(amount || 0).toLocaleString("fa-IR");

  const rows = [
    {
      label: "جمع قیمت کالاها",
      value: subtotal_amount,
    },
    {
      label: "تخفیف کالاها",
      value: discount_amount,
      isDiscount: Number(discount_amount) > 0,
    },
    {
      label: "قیمت کالاها پس از تخفیف",
      value: total_amount,
    },
    {
      label: "تخفیف کد هدیه",
      value: coupon_amount,
      isDiscount: Number(coupon_amount) > 0,
    },
    {
      label: "هزینه ارسال",
      value: shipping_amount,
    },
    {
      label: "مالیات",
      value: tax_amount,
    },
  ];

  return (
    <div>
      <div className="space-y-4">
        {rows.map((row) => (
          <div
            key={row.label}
            className="flex items-center justify-between gap-4 text-sm"
          >
            <span className="text-slate-500">{row.label}</span>

            <span
              className={
                row.isDiscount
                  ? "font-semibold text-emerald-600"
                  : "font-semibold text-slate-700"
              }
            >
              {row.isDiscount ? "-" : ""}
              {formatPrice(row.value)}
              <span className="mr-1 text-xs font-normal text-slate-400">
                تومان
              </span>
            </span>
          </div>
        ))}
      </div>

      <div className="my-5 border-t border-dashed border-slate-200" />

      <div className="rounded-xl bg-[#1E3A5F] px-4 py-4 text-white">
        <div className="flex items-center justify-between gap-3">
          <div>
            <p className="text-xs text-blue-100">مبلغ قابل پرداخت</p>
            <p className="mt-1 text-xl font-bold">
              {formatPrice(payable_amount)}
              <span className="mr-1 text-xs font-medium text-blue-100">
                تومان
              </span>
            </p>
          </div>

          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-white/10 text-[#FFC107]">
            <FiCreditCard className="h-5 w-5" />
          </div>
        </div>
      </div>
    </div>
  );
}
